<div [ngClass]="{'content-loading': loadState}">
    <div *ngIf="loadState" class="component-loadingBox">
        <!-- Cadastral map style loader (default) -->
        <div *ngIf="loaderType === 'parcels'" class="parcel-loader">
            <div class="cadastral-map" [ngClass]="'effect-' + loaderEffect">
                <div class="parcel p1"></div>
                <div class="parcel p2"></div>
                <div class="parcel p3"></div>
                <div class="parcel p4"></div>
                <div class="parcel p5"></div>
                <div class="parcel p6"></div>
                <div class="parcel p7"></div>
                <!-- Shimmer effect overlay -->
                <div *ngIf="loaderEffect === 'shimmer'" class="shimmer-overlay"></div>
                <!-- Scanline effect overlay -->
                <div *ngIf="loaderEffect === 'scanline'" class="scanline-overlay"></div>
            </div>
        </div>
        <!-- Classic spinner (fallback) -->
        <div *ngIf="loaderType === 'spinner'" class="spinner"></div>
        <p>{{loadText}}</p>
    </div>
    <ng-content></ng-content>
</div>